import React, { useState } from "react";
import Card from "./Card";
import Modal from "./Modal/Modal";
import Popup from "./Modal/Popup";
import SalePopup from "./Modal/SalePopup";
import Warning from "./Modal/Warning";
import converter from "number-to-words";
import Spinner from "./Spinner";
import card_top_img from "../../../assets/images/card_top-box.svg";
import { usePreview } from "../../../context/PreviewContextProvider";

const MyPage = () => {
  // Retrieving necessary data and functions from custom hooks and context
  const { data, previewCard, updatePreviewCard } = usePreview();

  // State hooks for various modals and card data
  const [saleShow, setSaleShow] = useState(false);
  const [saleStatus, setSaleStatus] = useState("");
  const [card, setCard] = useState({});
  const [spinner, setSpinner] = useState(false);
  const [warnShow, setWarnShow] = useState(false);
  const [deleteCard, setDeleteCard] = useState({});

  // Placeholder card data when previewCard is empty
  const placeholderCards = [
    {
      name: data.nft_name ? data.nft_name : 'NFT',
      price: 0,
      image: card_top_img,
      tokenId: 1,
      siteTokenIndex: 1,
      forSale: true,
      originalPrice: 0,
      address: "0xB50041BCb2284A6f5Febec3EB82ebBc62471beaC",
    },
    {
      name: data.nft_name ? data.nft_name : 'NFT',
      price: 0,
      image: card_top_img,
      tokenId: 1,
      siteTokenIndex: 1,
      forSale: false,
      originalPrice: 0,
      address: "0xB50041BCb2284A6f5Febec3EB82ebBc62471beaC",
    }
  ];

  // Functions to open/close various modals and update the respective states

  const openSaleModal = (card, btn) => {
    setCard(card);
    setSaleStatus(btn);
    setSaleShow(!saleShow);
  };

  const closeSaleModal = () => {
    setSaleShow(!saleShow);
  };

  // Function to handle NFT deletion with a warning modal
  const deleteNFT = async () => {
    setWarnShow(!warnShow);
    setSpinner(true);

    // Update preview cards after deletion
    const newArray = previewCard.filter((item) => item.id !== deleteCard.id);
    updatePreviewCard(newArray);

    // Extract IDs from deleteCard and send delete requests to server
    const ids = deleteCard.id.split("-");
    const url = `/api/mintpreview/previewnftdata/${ids[1]}`;
    await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    });
    await fetch(`/api/file/${ids[0]}`, {
      method: "DELETE",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    });
    setSpinner(false);
  };

  const openWarnModal = (card) => {
    setDeleteCard(card);
    setWarnShow(!warnShow);
  };

  const closeWarnModal = () => {
    setWarnShow(!warnShow);
  };

  // Functions to render various modals and popups based on the current state
  const renderWarnPopup = () => {
    return (
      <Modal show={warnShow} type={"warn"}>
        <Popup type={"warn"}>
          <Warning
            confirmAction={deleteNFT}
            onClose={closeWarnModal}
            text="Are you sure you want to delete this NFT?"
          />
        </Popup>
      </Modal>
    );
  };

  const renderSalePopup = () => {
    if (Object.keys(card).length > 0) {
      return (
        <Modal show={saleShow}>
          <Popup>
            <SalePopup
              card={card}
              show={saleShow}
              saleStatus={saleStatus}
              onClose={closeSaleModal}
            />
          </Popup>
        </Modal>
      );
    }
  };

  // Renders card data and displays placeholder cards if previewCard is empty
  const renderCardData = () => {
    return (
      <>
        {(
          previewCard.length === 0 ? (
            // Render placeholder cards if previewCard is empty
            <>
              {placeholderCards.map((card, index) => (
                <div className="nft-grid-card__wrapper" key={index}>
                  <Card
                    card={card}
                    btn={card.forSale ? "Cancel Sale" : "Sell"}
                    show={saleShow}
                    download={false}
                    overlay={false}
                    overlayText={card.forSale}
                    newest={true}
                    onBtnOpen={openSaleModal}
                  />
                </div>
              ))}
            </>
          ) : (
            // Render actual preview cards
            <>
              {previewCard.map((card, index) => (
                <div className="nft-grid-card__wrapper" key={index}>
                  <Card
                    card={card}
                    btn={card.forSale ? "Cancel Sale" : "Sell"}
                    show={saleShow}
                    download={false}
                    overlay={false}
                    overlayText={card.forSale}
                    newest={true}
                    onBtnOpen={openSaleModal}
                    delete_icon={previewCard.length === 0 ? false : true}
                    onDelete={() => openWarnModal(card)}
                  />
                </div>
              ))}
            </>
          )
        )}
      </>
    );
  };

  // Dynamically generate title based on preview count
  const getTitle = () => {
    if (previewCard.length === 0) {
      if (data.nft_name === null || data.nft_name === "") {
        return `My Two NFTs`;
      } else {
        return `My Two ${data.nft_name}`;
      }
    } else if (previewCard.length === 1) {
      return `My one ${data.nft_name === null || data.nft_name === "" ? "NFT" : data.nft_name
        }`;
    }
    else {
      return `My ${converter.toWords(previewCard.length)} ${data.nft_name === null || data.nft_name === "" ? "NFTs" : data.nft_name
        }`;
    }
  };

  return (
    <section id="mynft-page" className="page-settings">
      <Spinner spinner={spinner} />
      <div className="mynft-page__title-box row">
        <div className="col-12">
          <h1
            className="mynft-page__title title-styles"
            style={{ color: data.web_main_color }}
          >
            {getTitle()}
          </h1>
        </div>
      </div>
      {renderSalePopup()}
      <div
        className="nft-cards buy-cards"
        style={{ justifyContent: previewCard.length < 4 ? "center" : "" }}
      >
        {renderCardData()}
      </div>
      {renderWarnPopup()}
    </section>
  );
};

export default MyPage;
